"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var action_types_1 = require("./action-types");
var translations_1 = require("../translations");
exports.ROOT_KEY = 'client';
/******************
 * Initial state
 */
exports.defaultState = {
    passwordRules: {},
    clientCountries: [],
    clientBranding: {},
    localeList: [],
    busyFetchingClientData: false,
    busyFetchingClientCountries: false,
    loaded: false,
    defaultLocale: translations_1.DEFAULT_LOCALE.code
};
function setClientData(state, action) {
    var client = action.client;
    return tslib_1.__assign({}, state, { passwordRules: client.passwordRules, clientBranding: client.clientBranding, clientCountries: client.clientCountries, defaultLocale: client.defaultLocale, localeList: client.localeList, loaded: true });
}
exports.setClientData = setClientData;
function setClientCountries(state, action) {
    var clientCountries = action.clientCountries;
    return tslib_1.__assign({}, state, { clientCountries: clientCountries });
}
exports.setClientCountries = setClientCountries;
/******************
 * Reducer
 */
function rootReducer(state, action) {
    if (!state) {
        state = tslib_1.__assign({}, exports.defaultState);
    }
    switch (action.type) {
        case action_types_1.SET_CLIENT_DATA:
            return setClientData(state, action);
        case action_types_1.SET_CLIENT_COUNTRIES:
            return setClientCountries(state, action);
    }
    return state;
}
exports.default = rootReducer;
//# sourceMappingURL=reducers.js.map